export default __webpack_public_path__ + "static/media/JOOT_LOGO.ff7942bf.png";